import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calendar, Repeat, Waves, Sunrise, ArrowRight } from "lucide-react";

const classes = [
  {
    icon: Waves,
    cadence: "Weekly",
    title: "Nervous System Regulation",
    body: "A steady weekly rhythm of breath, gentle movement, and stillness — designed to help the body return to its natural rest state.",
  },
  {
    icon: Repeat,
    cadence: "Bi-Weekly",
    title: "Stability in Body & Practice",
    body: "For those building a sustainable relationship with their body — grounding, strengthening, and creating quiet confidence in the practice.",
  },
  {
    icon: Sunrise,
    cadence: "Monthly",
    title: "Deep Rest & Rejuvenation",
    body: "For active, busy lives — a longer, softer session focused on restoration, breath, and deep parasympathetic rest.",
  },
];

const UpcomingClasses = () => {
  return (
    <section
      data-testid="upcoming-classes"
      className="bg-[#FDFCFB] py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-xs tracking-[0.35em] uppercase text-[#7B8E76] mb-6">
            Group Offerings
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2D3A2B] leading-tight">
            Upcoming Yoga Therapy <span className="italic">Classes</span>.
          </h2>
          <p className="mt-6 text-lg text-[#4A5D46] leading-relaxed font-light">
            Alongside individualized sessions, small themed classes are offered
            regularly — designed around specific needs and gathered rhythms of
            practice.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {classes.map((c, i) => (
            <div
              key={c.title}
              data-testid={`class-card-${i}`}
              className="group bg-[#F4F1ED] rounded-md p-8 border border-transparent hover:border-[#C6A692] transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="w-11 h-11 rounded-full bg-[#FDFCFB] flex items-center justify-center text-[#4A5D46] group-hover:bg-[#8A9A83] group-hover:text-white transition-colors">
                  <c.icon className="w-5 h-5" aria-hidden />
                </span>
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#7B8E76] px-3 py-1 rounded-full border border-[#C6A692]">
                  {c.cadence}
                </span>
              </div>
              <h3 className="font-serif text-2xl text-[#2D3A2B] leading-snug mb-3">
                {c.title}
              </h3>
              <p className="text-sm text-[#4A5D46] leading-relaxed font-light">
                {c.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="text-sm text-[#7B8E76] italic">
            Curious about the current schedule?
          </p>
          <Link to="/contact" data-testid="classes-cta">
            <Button className="rounded-full bg-[#8A9A83] hover:bg-[#7B8E76] text-white px-6 py-4 h-auto">
              <Calendar className="w-4 h-4 mr-2" aria-hidden />
              Reach out for the upcoming dates
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UpcomingClasses;
